import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CoreSearchApiServiceImpl } from '@/infrastructure/api-functions/core-search-api.service';

import { CheckSensitiveWord } from '@/infrastructure/api-functions/interface/check-sensitive-word.interface';
import { GetTaskId } from '@/infrastructure/api-functions/interface/get-task-id.interface';
import { PutHistory } from '@/infrastructure/api-functions/interface/put-history.interface';
import { GetHistoryDetail } from '@/infrastructure/api-functions/interface/get-history-detail.interface';
import { GetTechMeans } from '@/infrastructure/api-functions/interface/get-tech-means.interface';
import { PutTechMeans } from '@/infrastructure/api-functions/interface/put-tech-means.interface';
import { GetDisclosureTitle } from '@/infrastructure/api-functions/interface/get-disclosure-title.interface';
import { GetDisclosureContent } from '@/infrastructure/api-functions/interface/get-disclosure-content.interface';
import { PutDisclosureSetting } from '@/infrastructure/api-functions/interface/put-disclosure-setting.interface';
import { InitDisclosureSetting } from '@/infrastructure/api-functions/interface/init-disclosure-setting.interface';
import { ExportDisclosure } from '@/infrastructure/api-functions/interface/export-disclosure.interface';
import { GetContentStorage } from '@/infrastructure/api-functions/interface/get-content-storage.interface';

export const serviceApiModule = new ContainerModule((bind) => {
    bind(CheckSensitiveWord).to(CoreSearchApiServiceImpl);
    bind(GetTaskId).to(CoreSearchApiServiceImpl);
    bind(PutHistory).to(CoreSearchApiServiceImpl);
    bind(GetHistoryDetail).to(CoreSearchApiServiceImpl);
    bind(GetTechMeans).to(CoreSearchApiServiceImpl);
    bind(PutTechMeans).to(CoreSearchApiServiceImpl);
    bind(GetDisclosureTitle).to(CoreSearchApiServiceImpl);
    bind(GetDisclosureContent).to(CoreSearchApiServiceImpl);
    bind(PutDisclosureSetting).to(CoreSearchApiServiceImpl);
    bind(InitDisclosureSetting).to(CoreSearchApiServiceImpl);
    bind(ExportDisclosure).to(CoreSearchApiServiceImpl);
    bind(GetContentStorage).to(CoreSearchApiServiceImpl);
});
